<template>
    <v-layout row align-center mb-3>
        <v-flex xs3 sm3 md3>
            <svg v-svg v-if="icon_exist"
                 :symbol="icon"
                 size="64"
                 role="presentation"
            />
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="64"
                 height="64" viewBox="0 0 64 64"
            >
                <g fill="none" fill-rule="evenodd">
                    <path fill="#D5D5D9" d="M40.235 4.52l12.983 13.377-8.439-.073c-2.509-.022-4.544-2-4.544-4.442V4.52zm.774-4.025A1.519 1.519 0 0 0 39.912 0H15.293C10.75 0 7 3.788 7 8.394v47.211C7 60.213 10.75 64 15.293 64h33.415C53.25 64 57 60.213 57 55.605V18.118c0-.402-.183-.788-.442-1.082L41.009.495z" />
                    <path fill="#bdb4b4" d="M0 55h64V31H0z" />
                    <text fill="#FFF" font-family="FuturisC" font-size="15"
                          style="text-transform: uppercase"
                    >
                        <tspan x="20%" y="48">{{ ext }}</tspan>
                    </text>
                    <path fill="#9b9b9b" d="M0 31.165h7V24.16zM64 31.165h-7V24.16z" />
                </g>
            </svg>
        </v-flex>
        <v-flex xs5 ml-3>
            <linkRed :href="link" target="_blank"><slot></slot></linkRed>
            <div class="grey-text">{{ ext_size }}</div>
        </v-flex>
    </v-layout>
</template>

<script>
import linkRed from '@/components/ui/links/styled/link_red.vue';
export default {
  components: {
    linkRed,
  },
  props: {
    icon: {
      type    : String,
      required: true,
    },
    ext: {
      type: String,
    },
    file_size: {
      type: String,
    },
    link: {
      type: String,
    },

  },
  computed: {
    ext_size() {
      return `${this.ext}, ${this.file_size}`;
    },
    icon_exist() {
      if (this.icon == 'pdf' || this.icon == 'xlsx' || this.icon == 'pptx') {
        return true;
      } else return false;
    },
  },
};
</script>

<style>

</style>
